// Reducer for the cluster of related "notification settings form" fields that
// were previously five separate useState hooks. These five always move together:
// they are reset to defaults (Add Webhook), hydrated as a group (Edit Webhook /
// initial load), and serialized together on save. Consolidating them removes the
// multi-render churn react-doctor/prefer-useReducer flags while preserving every
// update site's exact semantics — including the functional `prev =>` updates for
// the two collection fields (`quietHoursSlots`, `filterConfigs`).

export const DEFAULT_SLOT = () => ({ id: 1, from: '22:00', to: '08:00' });

export const initialSettings = {
    notificationType: 'summary',
    globalFrequency: '10m',
    quietHoursEnabled: false,
    quietHoursSlots: [DEFAULT_SLOT()],
    filterConfigs: {},
};

export function settingsReducer(state, action) {
    switch (action.type) {
        case 'SET_FIELD':
            return { ...state, [action.field]: action.value };

        // Functional update for a collection field. `updater` receives the current
        // value and returns the next one — preserving `setQuietHoursSlots(prev => ...)`
        // and `setFilterConfigs(prev => ...)` semantics exactly.
        case 'UPDATE_FIELD':
            return { ...state, [action.field]: action.updater(state[action.field]) };

        // Reset every field back to defaults (used by "Add Webhook").
        case 'RESET':
            return {
                notificationType: 'summary',
                globalFrequency: '10m',
                quietHoursEnabled: false,
                quietHoursSlots: [{ id: 1, from: '22:00', to: '08:00' }],
                filterConfigs: {},
            };

        // Hydrate from a saved/persisted settings object. Mirrors the original
        // conditional-set logic so absent keys keep their current value.
        case 'LOAD':
            return { ...state, ...action.values };

        default:
            return state;
    }
}
